<template>
<div class="describe-de-field-queries">
    <h3>Field: {{context.properties.Name}}</h3>
    <div v-for="(query, queryType) in queries" v-bind:key="queryType" class="field-query-container">
        <h4 v-if="queryType == 'aggregates'">Aggregate Information</h4>
        <h4 v-if="queryType == 'topN'">Top {{context.values.topN}} occurring value<span v-if="context.values.topN > 1">s</span></h4>
        <ProcessStatusView
            v-if="!query.complete"
            v-bind:processStatus="query.processStatus"
        />
        <div v-if="query.queryRunner && query.results">
            <div v-if="query.results.length">
                <DERowsTable
                    v-bind:rows="query.results"
                    v-bind:fields="Object.keys(query.results[0])"
                />
            </div>
            <div v-else>
                Result contains 0 rows
            </div>
            <!--<pre>{{query.queryRunner.queryResultObject}}</pre>-->
        </div>
    </div>
</div>
</template>

<script>
import QueryRunner from "@/services/ad-hoc-query-runner-2";
import ProcessStatusView, { ProcessStatus } from "@/components/ProcessStatusView"
import queryTemplate from './QueryTemplate';
import DERowsTable from '@/components/DERowsTable';

export default {
    name: 'DescribeDEFieldQueryView',
    components: {
        ProcessStatusView,
        DERowsTable
    },
    props: {
        dataExtensionSrc: Object,
        context: Object
    },
    data: function() {
        var queryTypes = ['aggregates', 'topN'];
        var data = {
            queryTypes,
            queries: (() => {
                var queries = {};
                queryTypes.forEach((queryType) => {
                    if (this.context.flags[queryType]) {
                        queries[queryType] = {
                            processStatus: new ProcessStatus(QueryRunner.STATE_IDLE),
                            queryRunner: null,
                            complete: false,
                            results: null
                        };
                    }
                });
                return queries;
            })()
        };
        return data;
    },
    mounted: function() {
        Object.keys(this.queries).forEach((queryType) => {
            //console.log('this.context');
            //console.log(JSON.stringify(this.context, null, 2));
            var query = this.queries[queryType];
            query.queryRunner = new QueryRunner(
                this,
                queryTemplate[queryType](this.context),
                {
                    retrieveResultObject: true
                },
                query.processStatus
            );
            query.queryRunner.run().then(
                () => {
                    query.results = [];
                    query.queryRunner.queryResultObject.forEach((resultRowStaging) => {
                        var resultRow = {};
                        Object.keys(resultRowStaging).forEach((fieldName) => {
                            var makeInserts;
                            if (queryTemplate.fieldDrops[queryType].indexOf(fieldName) == -1) {
                                makeInserts = queryTemplate.fieldInserts[fieldName];
                                resultRow[fieldName] = resultRowStaging[fieldName];
                                if (makeInserts) {
                                    makeInserts(resultRowStaging).forEach((insert) => {
                                        resultRow[insert.name] = insert.value;
                                    });
                                }
                            }
                        });
                        query.results.push(resultRow);
                    });
                    query.complete = true;
                    this.checkCompletion();
                },
                (error) => {
                    //console.error(error);
                    query.processStatus.state = QueryRunner.STATE_ERROR;
                    query.processStatus.error(
                        error.apiResponseMessage,
                        error.apiResponseRaw
                    );
                    query.complete = true;
                    this.checkCompletion();
                }
            );
        });
    },
    methods: {
        checkCompletion: function() {
            var complete = true;
            var results = {};
            Object.keys(this.queries).forEach((queryType) => {
                var query = this.queries[queryType];
                complete = complete && query.complete;
                results[queryType] = query.results;
            });
            if (complete) {
                this.$emit('DescribeDEFieldQuery:complete', this.context.properties.Name, results);
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .describe-de-field-queries {
        margin: .5em 0 .5em .5em;
        .field-query-container {
            margin: 0 0 0 .5em;
            .table-component__filter {
                display: none;
                border: 1px solid black;
            }
        }
    }
</style>
